<template>
    <div id="main">
        <div class="page">
            <div class="Permissao vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">{{ $t('grupopermissao') }}</h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <router-link :to="'/conta/escolher-permissao'">{{
                                        $t('settings')
                                    }}</router-link>
                                </li>
                                <li>
                                    <a href="#" aria-current="page">{{ $t('grupopermissao') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <router-link
                            class="save-btn"
                            type="button"
                            tag="button"
                            :to="{ name: 'new-grupopermissao' }"
                        >
                            {{ $t('adicionar') }}
                        </router-link>
                    </div>
                </div>

                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar :onSearch="debouncedOnSearch" />
                    </div>
                </div>

                <div class="Permissao-table registry-wrapper">
                    <b-table :data="allgp" :mobile-cards="false" class="data-table">
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :width="f.width"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :class="f.key != 'excluir' ? '' : 'excluir-field'"
                            :sortable="f.sortable"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'excluir'">
                                <div
                                    v-if="props.row.datahoradel"
                                    class="enable-btn"
                                    @click="confirmEnable(props.row)"
                                >
                                    <svg class="svg-icons">
                                        <use
                                            :xlink:href="
                                                require('@/assets/img/icons/check.svg') + '#layer'
                                            "
                                        ></use>
                                    </svg>
                                    <span class="delete-text">
                                        {{ $t('ativar') }}
                                    </span>
                                </div>
                                <div v-else class="delete-btn" @click="confirmExclusion(props.row)">
                                    <svg class="svg-icons">
                                        <use
                                            :xlink:href="
                                                require('@/assets/img/icons/inative.svg') + '#layer'
                                            "
                                        ></use>
                                    </svg>
                                    <span class="delete-text">
                                        {{ $t('inativar') }}
                                    </span>
                                </div>
                            </div>
                            <div v-else-if="f.key == 'descricao'">
                                <router-link
                                    :to="{
                                        name: 'edit-grupopermissao',
                                        params: { id: props.row.id },
                                    }"
                                >
                                    <pre>{{ props.row[f.key] }}</pre>
                                </router-link>
                            </div>
                        </b-table-column>
                    </b-table>
                    <b-pagination
                        :total="totalRows"
                        :current.sync="currentPage"
                        :per-page="perPage"
                        :order="'is-centered'"
                        @change="carregarGruposPermissoes"
                    >
                    </b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GrupoPermissaoService from '@/services/GrupoPermissaoService';

export default {
    data() {
        return {
            allgp: [],
            service: new GrupoPermissaoService(this.$http, this.$router),
            fields: [
                { key: 'descricao', width: null, sortable: true },
                { key: 'excluir', width: 70, sortable: false },
            ],
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            deleteThis: {},
            debouncedOnSearch: null,
            enableThis: null,
        };
    },
    created() {
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarGruposPermissoes();
    },
    methods: {
        confirmExclusion(item) {
            this.deleteThis = item;

            this.$root.confirm({
                message: this.$t('msg-confirm-inativar-grupopermissao', 
                    { n: item.descricao }
                ),
                onConfirm: this.excluir,
                onCancel: this.removePrompt,
            });
        },
        confirmEnable(item) {
            this.enableThis = item;

            this.$root.confirm({
                message: this.$t('msg-confirm-reativar-grupopermissao', 
                    { n: item.descricao }
                ),
                onConfirm: this.ativar,
                onCancel: this.removePrompt,
            });
        },
        onSearch(value) {
            this.queryFilter = value;
            this.carregarGruposPermissoes(1);
        },
        carregarGruposPermissoes(currentPage = 1) {
            this.$store.commit('addLoader');
            this.service
                .findAll(currentPage - 1, this.perPage, this.queryFilter)
                .then(this.mapItems)
                .then((value) => {
                    this.allgp = value;
                    this.totalRows = this.allgp.length;
                    this.$store.commit('removeLoader');
                });
        },
        mapItems(body) {
            let Permissaolist = body.content.map((p) => {
                return {
                    id: p.id,
                    descricao: p.descricao,
                    datahoradel: p.datahoradel,
                };
            });
            return Permissaolist;
        },
        excluir() {
            let item = this.deleteThis;
            this.$store.commit('addLoader');

            this.service
                .delete(item.id)
                .then((_) => {
                    this.$root.showMessage('success', 'msg-success-inativar-grupopermissao');
                    this.carregarGruposPermissoes();
                })
                .catch((e) => {
                    console.error('Erro ao inativar grupo de permissões.', e);
                    this.$root.showMessage('error', 'msg-failure-inativar-grupopermissao');
                    this.$store.commit('removeLoader');
                })
                .finally((_) => {
                    this.removePrompt();
                });
        },
        ativar() {
            let item = this.enableThis;
            this.$store.commit('addLoader');

            this.service
                .ativar(item.id)
                .then((_) => {
                    this.$root.showMessage('success', 'msg-success-reativar-grupopermissao');
                    this.carregarGruposPermissoes();
                })
                .catch((e) => {
                    console.error('Erro ao reativar grupo de permissões.', e);
                    this.$root.showMessage('error', 'msg-failure-reativar-grupopermissao');
                    this.$store.commit('removeLoader');
                })
                .finally((_) => {
                    this.removePrompt();
                });
        },
        removePrompt() {
            this.deleteThis = null;
            this.enableThis = null;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }

    .Permissao .search-and-filter {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .Permissao .search-and-filter .search-bar {
        width: 100%;
    }

    .Permissao .search-and-filter .filter-bar {
        width: 31%;
    }
}
</style>
